import type { PostHogEventProperties } from "@posthog/core"
import { ensurePosthogInitialized } from "./posthogClient.web"

// posthog-js has no screen() — $screen with $screen_name is what
// posthog-react-native sends, so navigation reads the same on both platforms.
export function trackScreen(routeName?: string, properties?: PostHogEventProperties) {
  if (!routeName) {
    return
  }

  ensurePosthogInitialized().capture("$screen", {
    ...properties,
    $screen_name: routeName,
  })
}
